import { Link } from 'react-router-dom';

import Img404 from '../../assets/img/illustrations/404.png';

const PageNotFound = () =>{
  return(
    <div className="container-fluid h-100 d-flex flex-column justify-content-center align-items-center bg-primary">
      <h2 className="text-white">
        page not found
      </h2>
      <div className="col-10 col-lg-6">
        <img
        src={Img404}
        alt="..."
        className="img-fluid"
        />
      </div>
      <Link
      to="/"
      className="btn btn-secondary">
        back to the beginning
      </Link>
    </div>
  )
}
export default PageNotFound;